import { useEffect, useState } from "react";

import { useApi } from "../../api";

const useUsers = () => {
  const api = useApi();
  const [users, setUsers] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/v2/users")
      .then(response => setUsers(response.data))
      .catch(() => {})
      .then(() => setLoading(false));
  }, [api]);

  return { users, isLoading };
};

export default useUsers;
